import { render, staticRenderFns } from "./AlertNotification.vue?vue&type=template&id=24267748"
import script from "./AlertNotification.vue?vue&type=script&lang=js"
export * from "./AlertNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports